/**
 * Wipe-guard for the edit dialog: only surface the prompt fields for update when
 * the live config was actually available (`promptLoaded`). Otherwise a save that
 * only touched an unrelated field (e.g. the name) would submit `''` and wipe the
 * template's agent when the API's guard-GET succeeds. (Create has no such guard:
 * a template's dedicated agent is authored from a required, always-present
 * prompt, so the container always sends it.)
 */
export function editAgentPromptFieldsForSubmit(values: {
  systemPrompt: string;
  firstMessage: string;
  promptLoaded: boolean;
}): { systemPrompt: string; firstMessage: string } | undefined {
  return values.promptLoaded
    ? { systemPrompt: values.systemPrompt, firstMessage: values.firstMessage }
    : undefined;
}
